<template>
  <div class="app-container">
    <base-header v-if="showType" activeIndex="6" />

    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/encyclopedia/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/encyclopedia/banner_wap.png" />

      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <h1 class="title">红狮投资百科</h1>
        <h1 class="titles">投资百科 </h1>
        <p class="banner-content-intro">专业金融知识库，涵盖平台资质、交易产品、出入金、工具使用等核心内容，<br>持续更新，助力每一位投资者做出更明智的决策。</p>
        <p class="banner-content-intros">专业金融知识库，涵盖平台资质、交易产品、出入金、<br>工具使用等核心内容，持续更新，<br>助力每一位投资者做出更明智的决策。</p>
        <p class="banner-content-intros2">
          香港黄金交易所AA类081号行员<br>
          16年运营积累
        </p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
          </router-link>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="encyclopedia-body">
      <div class="content-box">

        <div class="search-section">
          <div class="search-left">
            <div class="search-tabs">
              智能搜索
            </div>
            <div class="search-input-wrap">
              <input
                v-model="keyword"
                type="text"
                class="search-input"
                placeholder="搜索题目、标签"
                @keyup.enter="getDataList"
              />
              <span class="search-icon" @click="getDataList">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <circle cx="11" cy="11" r="7" stroke="#999" stroke-width="2"/>
                  <path d="M16.5 16.5L21 21" stroke="#999" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="search-right">
            <span class="cert-text">香港黄金交易所AA类081号行员 · 16年运营积累</span>
            <div v-if="showWap" class="expand-btns">
              <span class="expand-btn" @click="expandAll">全部展开</span>
              <span class="divider">|</span>
              <span class="expand-btn" @click="collapseAll" style="color: #93939F;">全部折叠</span>
            </div>
          </div>
        </div>

        <div class="article-list">
          <div v-if="displayList.length === 0 && !loading" class="empty-tip">暂无相关内容</div>
          <div
            v-for="item in displayList"
            :key="item.id"
            class="article-card"
          >
            <div class="card-header" @click="toggleItem(item.id)">
              <div class="header-left">
                <span class="art-title">{{ item.title }}</span>
              </div>
              <span class="art-date">{{ formatDate(item.creationTime) }}</span>
            </div>
            <div class="art-tags" v-if="item.tags && item.tags.length">
              <span v-for="tag in item.tags" :key="tag" class="art-tag">#{{ tag }}</span>
            </div>
            <div v-if="!isExpanded(item.id)" class="art-excerpt">{{ getExcerpt(item.content) }}</div>

            <div v-if="isExpanded(item.id)" class="art-content" v-html="item.content"></div>

            
            <div class="card-footer">
              <span
                class="toggle-btn"
                @click="toggleItem(item.id)"
              >{{ isExpanded(item.id) ? '收起▲' : '阅读全文▼' }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <base-footer v-if="showType" />
  </div>
</template>

<script>
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer'
import { queryEncyclopediaList } from '@/apis/index.js';
import { cmsKnowledgeTypeId } from '@/config';

export default {
  metaInfo: {
    title: '红狮金业百科|红狮金业投资知识|香港贵金属平台服务优势',
    meta: [
      { name: 'keywords', content: '红狮金业常见问题，红狮金业资质问答，贵金属交易问答，红狮金业出入金，红狮金业客服' },
      { name: 'description', content: '红狮金业立足香港，打造 7×24 小时全流程服务体系，多渠道客服全天候响应，配备新手指导、行情资讯等配套服务，服务全球贵金属投资者，交易服务省心高效。' }
    ]
  },
  components: {
    BaseHeader,
    BaseFooter,
  },
  data() {
    return {
      showWap: document.body.clientWidth > 500 ? false : true,
      screenWidth: document.body.clientWidth,
      showType: true,
      loading: false,
      list: [],
      displayList: [],
      keyword: '',
      searchMode: 'smart',
      expandedIds: [],
      searchTabs: [
        { label: '智能搜索', value: 'smart' },
        { label: '文字标题', value: 'title' },
        { label: '标签', value: 'tag' },
      ],
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false
    };
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.loading = true
      const params = {
        businessPlatform: 4,
        // knowledgeTypeId: 7103,  // 本地
        knowledgeTypeId: 273,  // 线上
        keyWords: this.keyword,
        maxResultCount: 99,
        skipCount: 0,
        terminal: 4,
      }
      queryEncyclopediaList(params).then(res => {
        if (res && res.result) {
          this.list = res.result.items || []
          this.displayList = this.list.slice()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    switchMode(mode) {
      this.searchMode = mode
    },
    
    toggleItem(id) {
      const idx = this.expandedIds.indexOf(id)
      if (idx > -1) {
        this.expandedIds.splice(idx, 1)
      } else {
        this.expandedIds.push(id)
      }
    },
    isExpanded(id) {
      return this.expandedIds.indexOf(id) > -1
    },
    getExcerpt(content) {
      const textLength = this.showWap ? 45 : 100;
      if (!content) return ''
      const text = content.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
      return text.length > textLength ? text.slice(0, textLength) + '...' : text
    },
    expandAll() {
      this.expandedIds = this.displayList.map(item => item.id)
    },
    collapseAll() {
      this.expandedIds = []
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      return dateStr.slice(0, 10)
    },
  }
}
</script>

<style lang="less" scoped>
.app-container {
  background: #f5f5f5;

  .content-box {
    width: 1240px;
    margin: auto;
    box-sizing: border-box;
  }

  .banner__layer {
    position: relative;

    .banner-img {
      display: block;
      width: 100%;
    }

    .banner-imgs {
      display: none;
      width: 100%;
    }

    .banner-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #FFFFFF;

      .title {
        display: block;
      }

      .titles {
        display: none;
      }

      h1 {
        font-size: 68px;
        margin: 0;
      }

      &-intro {
        font-size: 18px;
      }
      &-intros, &-intros2 {
        display: none;
      }

      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .encyclopedia-body {
    padding: 24px 0 48px;
    position: relative;
    top: -60px;

    .search-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      border-radius: 4px;
      padding: 24px 60px;
      margin-bottom: 56px;
      box-shadow: 0 1px 4px rgba(0,0,0,0.06);

      .search-left {
        display: flex;
        align-items: center;
        gap: 12px;

        .search-tabs {
          font-size: 14px;
          font-weight: 600;
        }

        .search-input-wrap {
          display: flex;
          align-items: center;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          overflow: hidden;
          width: 200px;

          .search-input {
            flex: 1;
            height: 32px;
            border: none;
            outline: none;
            padding: 0 10px;
            font-size: 13px;
            color: #333;
            background: transparent;
            width: 140px;

            &::placeholder {
              color: #bbb;
            }
          }

          .search-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 32px;
            cursor: pointer;
            background: #f9f9f9;
            border-left: 1px solid #e0e0e0;
          }
        }
      }

      .search-right {
        .cert-text {
          color: #FA2314;
          font-size: 13px;
          font-weight: 500;
          white-space: nowrap;
        }
      }
    }

    .article-list {
      .empty-tip {
        text-align: center;
        color: #999;
        padding: 60px 0;
        font-size: 14px;
      }

      .article-card {
        background: #fff;
        margin-bottom: 12px;
        padding: 20px 24px 14px;
        border-radius: 4px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.06);

        .card-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          cursor: pointer;
          gap: 16px;

          .header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            flex: 1;
            min-width: 0;

            .cat-tag {
              flex-shrink: 0;
              display: inline-block;
              padding: 2px 8px;
              border-radius: 3px;
              color: #fff;
              font-size: 12px;
              font-weight: 500;
              white-space: nowrap;
            }

            .art-title {
              font-size: 15px;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 1.5;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .art-date {
            flex-shrink: 0;
            font-size: 12px;
            color: #999;
            margin-top: 3px;
          }
        }

        .art-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-top: 10px;

          .art-tag {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 2px;
            font-size: 12px;
            color: #0059FF;
            background: rgba(0, 89, 255, 0.1);
          }
        }

        .art-excerpt {
          margin-top: 10px;
          font-size: 13px;
          color: #666;
          line-height: 1.7;
        }

        .art-content {
          margin-top: 12px;
          font-size: 14px;
          color: #333;
          line-height: 1.8;

          /deep/ p {
            margin: 0 0 12px;
          }

          /deep/ ul, /deep/ ol {
            padding-left: 20px;
            margin: 8px 0;
          }

          /deep/ p, /deep/ span, /deep/ div {
            text-wrap-mode: wrap !important;
          }
        }

        .card-footer {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 12px;
          padding-top: 10px;
          border-top: 1px solid #f0f0f0;

          .toggle-btn {
            font-size: 13px;
            color: #999;
            cursor: pointer;
            white-space: nowrap;
            transition: color 0.2s;
            color: #FA2314;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .app-container {
    .banner__layer {
      padding-top: 45px;

      .banner-img {
        display: none;
      }

      .banner-imgs {
        display: block;
        height: 500px;
      }

      .banner-content {
        position: absolute;
        top: 37%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        padding-top: 40px;
        background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);
        color: #FFFFFF;
        width: 100%;

        .title {
          display: none;
        }

        .titles {
          color: #FFFFFF;
          display: block;
        }

        h1 {
          font-size: 58px;
          line-height: 77px;
          margin: 0;
          width: 100%;
          text-align: center;
          white-space: wrap;
        }
        &-intro {
          display: none;
        }
        &-intros {
          margin-top: 10px;
          display: block;
          font-size: 14px;
          text-align: center;
        }
        &-intros2 {
          font-size: 14px;
          text-align: center;
          margin-top: 10px;
          display: block;
          color: #FA2314;
        }

        &-download {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 20px;

          &-btn {
            width: 180px;
            line-height: 34px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 20px;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #FFFFFF;
              padding: 2px 20px;
              font-size: 10px;

              &:first-child {
                border-right: 1px solid #fff;
              }

              img {
                width: 24px;
                height: 24px;
                margin-right: 12px;
              }
            }
          }
        }
      }

      .banner-co {
        top: 33%;
      }
    }

    .bannerss {
      padding-top: 0;
    }

    .content-box {
      width: 100%;
      padding: 0 12px;
      box-sizing: border-box;
    }

    .encyclopedia-body {
      padding: 12px 0 32px;
      position: relative;
      top: -40px;

      .search-section {
        gap: 10px;
        padding: 12px;
        margin-bottom: 26px;

        .search-left {
          flex-wrap: wrap;
          gap: 8px;
          width: 100%;

          .search-tabs {
            display: none;
          }

          .search-input-wrap {
            width: 180px;

            .search-input {
              width: 120px;
            }
          }
        }

        .search-right {
          .cert-text {
            display: none;
            font-size: 12px;
          }

          .expand-btns {
            display: flex;
            align-items: center;
            gap: 4px;
            white-space: nowrap;

            .expand-btn {
              font-size: 13px;
              color: #FA2314;
              cursor: pointer;
            }

            .divider {
              font-size: 13px;
              color: #ccc;
            }
          }
        }
      }

      .article-list {
        .article-card {
          padding: 14px 12px 10px;

          .card-header {
            .header-left {
              .art-title {
                font-size: 14px;
                white-space: normal;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .app-container {
    .content-box {
      width: 1000px;
    }

    .banner__layer {
      position: relative;

      .banner-img {
        display: block;
        width: 100%;
      }

      .banner-imgs {
        display: none;
        width: 100%;
      }

      .banner-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        color: #FFFFFF;

        .title {
          display: block;
        }

        .titles {
          display: none;
        }

        h1 {
          font-size: 50px;
          margin: 0;
        }

        &-intro {
          font-size: 18px;
        }

        &-download {
          display: flex;
          align-items: center;
          margin-top: 50px;

          &-btn {
            width: 198px;
            line-height: 56px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            display: inline-block;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #FFFFFF;
              padding: 4px 40px;

              &:first-child {
                border-right: 1px solid #0F0F11;
              }

              img {
                width: 38px;
                height: 38px;
                margin-right: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
